module.exports = __webpack_public_path__ + "static/ngebiz-logo-nav-75d56aabe4e12bbf08d887553c842605.png";